import {inject} from 'mobx-react'
import React, {useContext, useEffect, useState} from 'react'
import {withRouter} from 'react-router-dom'
import {Page_settings} from '../../config/page_settings'
import {rootStore} from '../../mobx/store'
import strings from '../../lang/strings'
import AppInput from '../../components/control/custom_input/app_input'
import ConfirmButton from '../../components/control/button/confirm_button'
import {checkEmail, checkPwd, getTimeFromSecond, string} from '../../helper/common'
import {AUTH_TIME} from '../../config/const'

const Find = (props) => {
  const context = useContext(Page_settings)
  let [type, setType] = useState(0)
  let [findType, setFindType] = useState(1) //0-phone, 1-email
  let [step, setStep] = useState(1)
  let [name, setName] = useState('')
  let [phone, setPhone] = useState('')
  let [email, setEmail] = useState('')
  let [auth, setAuth] = useState('')
  let [authStatus, setAuthStatus] = useState(-1)
  let [nameError, setNameError] = useState('')
  let [phoneError, setPhoneError] = useState('')
  let [emailError, setEmailError] = useState('')
  let [authError, setAuthError] = useState('')
  let [pwd, setPwd] = useState('')
  let [pwdD, setPwdD] = useState('')
  let [pwdError, setPwdError] = useState('')
  let [pwdDError, setPwdDError] = useState('')
  let [title, setTitle] = useState('')
  let [desc, setDesc] = useState('')
  let [findResult, setFindResult] = useState(false)
  let [authTime, setAuthTime] = useState(AUTH_TIME)
  let [confirmBtn, setConfirmBtn] =  useState(strings.confirm)
  let [countDown, setCountDown] = React.useState(0)
  let [id, setId] = React.useState('')
  let [enableAuth, setEnableAuth] = useState(false)
  let [enableConfirm, setEnableConfirm] = useState(false)

  useEffect(() => {
    init()
  }, [props.match.params.type])

  useEffect(() => {
    setAuthError('')
    setEnableConfirm(auth !== '' && name !== '')
  }, [auth])

  useEffect(() => {
    setNameError('')
  }, [name])

  useEffect(() => {
    setPhoneError('')
    if (findType !== 0) return
    const phone1 = phone.replace(/-/g, '').replace(/ /g, '')
    setEnableAuth(phone1.length === 11 && authStatus !== 1)
  }, [phone])

  useEffect(() => {
    setEmailError('')
    if (findType !== 1) return
    setEnableAuth(checkEmail(email) && authStatus !== 1)
  }, [email])

  useEffect(() => {
    setPwdError('')
  }, [pwd])

  useEffect(() => {
    setPwdDError('')
  }, [pwdD])

  useEffect(() => {
    if (authTime === 0) {
      setAuthTime(AUTH_TIME)
      setAuthStatus(0)
      setAuth('')
      clearInterval(countDown)
    }
  }, [authTime])

  const init = () => {
    let type = parseInt(props.match.params.type)
    setType(type)
    if (type === 0) {
      setTitle(strings.find_id)
      setDesc(strings.find_id_desc)
    } else if (type === 1) {
      setTitle(strings.find_pwd)
      setDesc(findType == 0 ? strings.find_phone_desc : strings.find_email_desc)      
    }
  }

  const changeType = (t) => {
    setFindType(t)
    setDesc(t === 0 ? strings.find_phone_desc : strings.find_email_desc)
    setAuthTime(AUTH_TIME)
    setAuthStatus(-1)
    setEnableAuth(false)
    setPhone('')
    setEmail('')
    setAuth('')
    setName('')
    clearInterval(countDown)
    if (type === 0) {
      setPhone('')
    } else {
      setEmail('')
    }
  }

  const changeFindType = (t) => {
    if (findType === t) return
    if (authStatus === 1) {
      context.showConfirm(strings.ask_cancel_auth, (val) => {
        if (!val) return
        changeType(t)
      })
      return
    }
    changeType(t)
  }

  const sendAuth = () => {
    if (!enableAuth) return
    if (findType === 0 && phone === '') {
      setPhoneError(strings.phone_hint)
      return
    }
    if (findType === 1 && email === '') {
      setEmailError(strings.email_hint)
      return
    }
    if (findType ===1 && !checkEmail(email)) {
      setEmailError(strings.invalid_email)
      return
    }
    context.post('member/requestAuth', {type: findType === 0 ? 'phone' : 'email', key: findType === 0 ? phone : email, findType: findType},
      () => {
        setPhoneError('')
        setAuthStatus(1)
        setEnableAuth(false)
        setAuthTime(AUTH_TIME)
        clearInterval(countDown)
        setCountDown(setInterval(() => {
          setAuthTime(prevTime => prevTime - 1)
        }, 1000))
      },
      true,
      err => {
        context.showAlert(err.msg)
      }
    )
  }

  const handleFind = () => {
    if (!enableConfirm) return
    if (step === 2 && type === 0) {
      props.history.replace(findResult ? '/login' : '/signup')
      return
    }
    let enable = true
    if (step === 2 && type === 1) {
      if (pwd === '') {
        enable = false
        setPwdError(strings.pwd_hint)
      }
      if (enable && !checkPwd(pwd)) {
        enable = false
        setPwdError(strings.invalid_pwd)
      }
      if (pwdD === '') {
        enable = false
        setPwdDError(strings.pwd_hint)
      }
      if (pwd !== pwdD) {
        enable = false
        setPwdDError(strings.pwd_mismatch)
      }
      if (!enable) return
      context.post('member/resetPassword', {id: id, pwd: pwd},
        () => {
          context.showAlert(strings.reset_pwd_complete, function () {
            props.history.replace('/login')
          }, strings.login)
        },
        true,
        err => {
          context.showAlert(err.msg)
        }
      )
      return
    }

    if (name === '') {
      enable = false
      setNameError(strings.name_hint)
    }
    if (auth === '') {
      enable = false
      setAuthError(strings.input_auth)
    }
    if (!enable) return
    context.post('member/confirmAuth', {type: 'find', key: findType === 0 ? phone : email, val: auth, name: name, findType: findType},
      response => {
        clearInterval(countDown)
        const r = response.find == 1
        setFindResult(r)
        setConfirmBtn(!r ? strings.signup : (type === 0 ? strings.login : strings.change))
        setId(response.mb_email)
        setStep(2)
      },
      true,
      err => {
        setAuthError(err.msg)
      }
    )
  }

  return (
    <React.Fragment>
      <div className='sign-bg'>
        <div className='find-bg'>
          <div className='fs-28 sm-fs-20 f-b color-0f4c81'>{title}</div>
          <div className='mt-30 sm-mt-40'>
            <div className='find-div'>
              {step === 1 &&
              <React.Fragment>
                {type === 0 && <div className='fs-20 sm-fs-16 f-b'>{strings.find_phone}</div>}
                {type === 1 &&
                <div className={'d-flex'}>
                  {/* <div className={'flex-full fs-20 sm-fs-16 f-b cursor-point bd-0 ' + (findType === 0 ? 'chat-tab-active' :'chat-tab-normal')} onClick={() => changeFindType(0)}>{strings.find_phone}</div> */}
                  {/* <div className={'flex-full fs-20 sm-fs-16 f-b cursor-point bd-0 ' + (findType === 1 ? 'chat-tab-active' :'chat-tab-normal')} onClick={() => changeFindType(1)}>{strings.find_email}</div> */}
                  <div className={'flex-full fs-20 sm-fs-16 f-b cursor-point bd-0 ' + (findType === 1 ? 'chat-tab-active' :'chat-tab-normal')}>{strings.find_email}</div>
                </div>
                }
                <div className='fs-16 sm-fs-14 f-m fls-1 color-9e9e9e mt-20 sm-mt-10'>{desc}</div>
                <AppInput className={'mt-30'} errorMsg={nameError} placeholder={strings.name} inputType={'text'} value={name} onChange={(v) => {setName(v)}}/>
                <div className='auth_div2 mt-12'>
                  <input className={'form-control flex-full'} placeholder={findType === 0 ? strings.phone : strings.email} readOnly={authStatus === 1} type={findType === 0 ? 'tel' : 'email'} value={findType === 0 ? phone : email} onChange={(e) => findType === 0 ? setPhone(e.target.value) : setEmail(e.target.value)}/>
                  <ConfirmButton enabled={enableAuth} className='btn-login ml-4 ' onClick={sendAuth} text={authStatus === -1 ? strings.send_auth : strings.re_auth} />
                </div>
                <div className={'invalid-feedback error flex-full'}>{findType === 0 ? phoneError : emailError}</div>
                {authStatus === 1 &&
                <React.Fragment>
                  <div className='d-center'>
                    <div className={'invalid-feedback error flex-full'}>{ findType === 0? strings.auth_sent : strings.auth_sent_by_email }</div>
                    <div className={'fs-14 sm-fs-12 f-m color-9e9e9e mr-4 mt-6'}>{getTimeFromSecond(authTime)}</div>
                  </div>
                  <AppInput className={'mt-12'} errorMsg={authError} placeholder={strings.auth_hint} inputType={'text'} value={auth} onChange={(v) => {setAuth(v)}}/>
                </React.Fragment>
                }
              </React.Fragment>
              }
              {step === 2 &&
              <React.Fragment>
                {!findResult && <div className='fs-20 sm-fs-16 f-sb space-break'>{strings.find_id_fail}</div>}
                {type === 0 && findResult && <div className='fs-20 sm-fs-16 f-sb space-break'>{string.Format(strings.find_id_result, name, id)}</div>}
                {type === 1 && findResult &&
                <React.Fragment>
                  <div className='fs-20 sm-fs-16 f-b'>{strings.reset_pwd}</div>
                  <div className='fs-16 sm-fs-14 f-m fls-1 color-9e9e9e mt-20 space-break'>{strings.reset_pwd_desc}</div>
                  <AppInput className={'mt-20'} errorMsg={pwdError} placeholder={strings.new_pwd} inputType={'password'} value={pwd} onChange={(v) => { setPwd(v) }} />
                  <AppInput className={'mt-10'} errorMsg={pwdDError} placeholder={strings.new_pwd_d} inputType={'password'} value={pwdD} onChange={(v) => { setPwdD(v) }} />
                </React.Fragment>
                }
              </React.Fragment>
              }
            </div>
            {(step === 2 || authStatus === 1) &&
            <div className='d-center mt-30'>
              <ConfirmButton enabled={enableConfirm} className={'btn btn-find btn-login fs-15 f-sb '} onClick={handleFind} text={confirmBtn} />
            </div>
            }
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default withRouter(inject('rootStore')(Find))
